import * as Yup from 'yup';

/**
 * This is specifically for bulk updates;
 * for this reason, many fields that are normally
 * required are optional.
 * DO NOT USE THIS TO VALIDATE INDIVIDUAL ENTRIES!
 */
// eslint-disable-next-line import/prefer-default-export
export const bulkListingValidator = Yup
  .object()
  .shape({
    name: Yup.string()
      .nullable()
      .matches(
        /^[A-Za-z\s-]+$/,
        'Name must only contain letters and -',
      )
      .max(25, 'Name cannot exceed 25 characters'),
    price: Yup
      .number()
      .positive()
      .nullable()
      .min(0),
    sale_price: Yup
      .number()
      .nullable()
      .min(0)
      .lessThan(
        Yup.ref('price'),
        'Sale price must be less than Original price.',
      ),
    sex: Yup
      .string()
      .nullable()
      .oneOf(['male', 'female']),
    // TODO: How to handle this, given that color is linked to breed?
    color: Yup
      .object()
      .shape({
        label: Yup.string(),
        value: Yup.number(),
      })
      .nullable()
      .required('Color is required.'),
    date_available: Yup
      .string()
      .nullable(),
    expires_at: Yup
      .string()
      .nullable()
      .when('remove_can_expire', {
        is: (remove_can_expire) => remove_can_expire,
        then: Yup
          .string()
          .nullable()
          .oneOf(['', null], 'Cannot set an expiration when expiration is removed.'),
      }),
    remove_can_expire: Yup
      .boolean(),
    sold_at: Yup
      .string()
      .nullable(),
    registration: Yup
      .array()
      .of(
        Yup.string().nullable(),
      )
      .nullable(),
    availability: Yup
      .string()
      .oneOf([
        'available',
        'sold',
        'pending',
      ])
      .when('sold_at', {
        is: (sold_at) => sold_at,
        then: Yup
          .string()
          .matches(/sold/, 'Ads must be marked sold if a sold date is set'),
      })
      .nullable(),
    ad_type: Yup
      .string()
      .oneOf([
        'basic',
        'advanced',
        'premium',
      ])
      .nullable(),
    description: Yup
      .string()
      .transform((_, original) => original.replace(/(<([^>]+)>)/gi, ''))
      .max(2000, 'Descriptions can be no more than 2000 characters in length.')
      .nullable(),
    deposit_price: Yup
      .number()
      .typeError('Deposit Price must be a number')
      .nullable()
      .min(100, 'Deposit price must be greater than or equal to $100')
      .max(1000, 'Deposit price must be less than or equal to $1000')
      .notRequired()
      .when('price', {
        is: (original) => original < 1000,
        then: Yup.number()
          .nullable()
          .notRequired()
          .max(
            Yup.ref('price'),
            'Deposit price must be less than or equal to Original price',
          ),
      })
      .when('sale_price', {
        is: (sale) => sale && sale < 1000,
        then: Yup.number()
          .nullable()
          .notRequired()
          .max(
            Yup.ref('sale_price'),
            'Deposit price must be less than or equal to Sale price',
          ),
      }),
    size: Yup
      .string()
      .nullable(),
    external_video_url: Yup
      .string()
      .url('Please enter a valid link that begins with \'https://\'')
      .matches(
        /^(https:\/\/(www.)?youtube.com\/watch\?v=([^&\n]+)&?)$|^(https:\/\/youtu.be\/([^&\n]+)&?)$|(https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:|\/\?)/,
        'Please enter a valid link that begins with \'https://\'',
      )
      .nullable(),
    external_media: Yup
      .array()
      .of(
        Yup
          .object()
          .shape({
            source_type: Yup
              .string()
              .oneOf(['youtube', 'vimeo'])
              .required(),
            sort_id: Yup
              .number()
              .nullable(),
            resource_link: Yup
              .string()
              .url('Please enter a valid link that begins with \'https://\'')
              .matches(
                /^(https:\/\/(www.)?youtube.com\/watch\?v=([^&\n]+)&?)$|^(https:\/\/youtu.be\/([^&\n]+)&?)$/,
                'Please enter a valid link that begins with \'https://\'',
              )
              .required(),
          }),
      )
      .max(3)
      .nullable(),
  });

export const sellerBulkListingPriceChangeValidator = Yup
  .object()
  .shape({
    price: Yup
      .number()
      .positive()
      .nullable()
      .min(0),
    sale_price: Yup
      .number()
      .nullable()
      .min(0)
      .lessThan(
        Yup.ref('price'),
        'Sale price must be less than Original price.',
      ),
    deposit_price: Yup
      .number()
      .typeError('Deposit Price must be a number')
      .nullable()
      .min(100, 'Deposit price must be greater than or equal to $100')
      .max(1000, 'Deposit price must be less than or equal to $1000')
      .notRequired()
      .when(['price', 'sale_price'], {
        is: (price, salePrice) => !price && !salePrice,
        then: Yup.number()
          .nullable()
          .notRequired()
          .max(0, 'Deposit price cannot be set if neither price nor sale price is enabled.'),
      })
      .when('price', {
        is: (original) => original < 1000,
        then: Yup.number()
          .nullable()
          .notRequired()
          .max(
            Yup.ref('price'),
            'Deposit price must be less than or equal to Original price',
          ),
      })
      .when('sale_price', {
        is: (sale) => sale && sale < 1000,
        then: Yup.number()
          .nullable()
          .notRequired()
          .max(
            Yup.ref('sale_price'),
            'Deposit price must be less than or equal to Sale price',
          ),
      }),
  });
